export default __webpack_public_path__ + "static/media/seaborn.ab44f30a.svg";